import { render, staticRenderFns } from "./CarInformations.vue?vue&type=template&id=1ab5922a&scoped=true"
import script from "./CarInformations.vue?vue&type=script&lang=js"
export * from "./CarInformations.vue?vue&type=script&lang=js"
import style0 from "./CarInformations.vue?vue&type=style&index=0&id=1ab5922a&prod&lang=scss&scoped=true"
import style1 from "./CarInformations.vue?vue&type=style&index=1&id=1ab5922a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5922a",
  null
  
)

export default component.exports